import React from 'react';
import { seatBands, type SeatBandCode } from '../../config/seatBands';
import { cn } from '../../lib/utils';

export function PricingSeatBandToggle({
  selectedBand,
  onSelect,
  labelForBand,
  ariaLabelledBy,
  className,
}: {
  selectedBand: SeatBandCode;
  onSelect: (band: SeatBandCode) => void;
  labelForBand: (band: SeatBandCode) => string;
  ariaLabelledBy?: string;
  className?: string;
}): React.JSX.Element {
  return (
    <div
      role="group"
      aria-labelledby={ariaLabelledBy}
      className={cn(
        'inline-flex max-w-full flex-wrap gap-1 rounded-[1.75rem] border border-brand-primary/10 bg-brand-bg p-1',
        className
      )}
    >
      {seatBands.map((band) => (
        <button
          key={band.code}
          type="button"
          aria-pressed={selectedBand === band.code}
          onClick={() => onSelect(band.code)}
          className={cn(
            'min-h-11 rounded-full px-5 py-2.5 text-xs font-bold tracking-[0.04em] transition-all',
            selectedBand === band.code
              ? 'bg-brand-primary text-white shadow-sm'
              : 'text-[var(--ir-muted)] hover:bg-white'
          )}
        >
          {labelForBand(band.code)}
        </button>
      ))}
    </div>
  );
}
